import { FC } from 'react'

import { Box, Step, StepLabel, Stepper } from '@mui/material'

export interface IProps {
  activeStep: number
  total: number
}
const LearningStyleStepper: FC<IProps> = ({ activeStep, total }) => {
  const steps = Array.from({ length: total }).map((el, i) => ({ label: i + 1 }))
  return (
    <Box sx={{ width: '100%', padding: '1rem' }}>
      <Stepper activeStep={activeStep} orientation='horizontal'>
        {steps.map((step, index) => ( 
          <Step key={index} sx={{ height: '2rem', paddingLeft: '6px', paddingRight: '6px' }}>
            <StepLabel/>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}

export default LearningStyleStepper
